import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect, useState } from "react";
import { IMAGE_GEEKO_LTD } from "../../../../../../../constants";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import classes from './style.module.scss';

export const SelectType = (props) => {
    useStyles(classes)
    const {type:propsType, value, itemList, intl, selectChange} = props
    const [select, setSelect] = useState(false)
    const [open, setOpen] = useState(false)
    const [type, setType] = useState(propsType || "order") // chat

    useEffect(()=>{
        if(propsType == "chat"){
            if(value){
                setSelect(itemList.find(i => i.value == value)?.label || intl.formatMessage({id: 'select_tip'}))
            } else {
                setSelect(intl.formatMessage({id: 'select_tip'}))
            }
        } else if(itemList.length > 0){
            setSelect(itemList?.[0]?.label)
        }
    },[value])
    

    const itemClick = (item) => {
        if(type == 'chat'){
            selectChange(item).then(res => {
                if(res){
                    setSelect(item.label);
                }
                setOpen(false);
            })
        } else {
            selectChange(item)
            setSelect(item.label);
            setOpen(false);
        }
    }

    return(
        <div className={classes.SelectTypeBox}>
            {
                type == "order" &&
                <React.Fragment>
                    <div className={classes.SelectInputBox} onClick={() => setOpen(!open)}>
                        {select}
                        <img className={classes.SelectIcon} style={{transform: open ? 'rotate(180deg)': 'rotate(0deg)'}} src={`${IMAGE_GEEKO_LTD}/site/pc/icon137.png`} alt="" />
                    </div>
                    {
                        open &&
                        <div className={classes.SelectOptionBox}>
                            {
                                itemList?.map((item, index)=>{
                                    return <div className={classes.SelectOption}
                                                key={index}
                                                style={{backgroundColor: select==item.label?'#f6f6f6':''}}
                                                onClick={()=>itemClick(item)}>
                                                    {item.label}
                                            </div>
                                })
                            }
                        </div>
                    }
                </React.Fragment>
            }
            {
                type == "chat" &&
                <React.Fragment>
                    <div className={classes.Radius} onClick={() => setOpen(!open)}>
                        {select}
                        <img className={classes.SelectIcon} style={{transform: open ? 'rotate(180deg)': 'rotate(0deg)'}} src="https://image.geeko.ltd/site/pc/icon137.png" alt="" />
                    </div>
                    {
                        open&&
                        <div className={classes.SelectOptionBox} style={{left: '8%',width: '84%'}}>
                            {
                                itemList?.map((item, index)=>{
                                    return <div className={classes.SelectOption} key={index} style={{backgroundColor: select==item.label?'#f6f6f6':''}} onClick={()=>itemClick(item)}>{item.label}</div>
                                })
                            }
                        </div>
                    }
                </React.Fragment>
            }
        </div>
    )
}

export const TypeSelect = props => {
    useStyles(classes)
    const {intl, questions, selectChange, subject, type} = props

    return (
        <div>
            <div className={classes.HelpTxt}>{intl.formatMessage({id: 'help_you'})}</div>
            <SelectType itemList={questions} selectChange={(e)=>selectChange(e)} type={type} value={subject} intl={intl}/>
        </div>
    )
}